import API from '@kimuno/api-sdk';
import config from 'config';
import muiProgress from '../utils/muiProgress';
import { isSchoolSubdomain } from '../utils/subdomain';
import cookies from './cookies';

const realm = isSchoolSubdomain(window.location.hostname) ? 'schulen' : 'mu';

const api = new API({
  progress: muiProgress,
  realm,
  tokenProvider: {
    deleteToken: cookies.deleteAuthToken,
    // @kimuno/api-sdk's tokenProvider contract requires a plain string; an unauthenticated
    // request already fails the same way whether the header is empty or missing entirely.
    getToken: () => cookies.getAuthToken() ?? '',
    setToken: cookies.setAuthToken,
    type: 'token',
  },
  url: config.urls.api,
});

export default api;
